import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { AcademicState, SetLicenseScope } from '@platform-frontend/checkout';
import { LicenseScope } from '@platform-frontend/marketplace';
import { Navigate } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

interface TeacherToggleForm {
  licenseScope: FormControl<LicenseScope>;
}

@UntilDestroy()
@Component({
  selector: 'yat-teacher-toggle',
  templateUrl: './teacher-toggle.component.html',
  styleUrls: ['./teacher-toggle.component.scss']
})
export class TeacherToggleComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private store: Store) {}

  readonly teacherToggleForm = new FormGroup<TeacherToggleForm>({
    licenseScope: new FormControl('PERSONAL_USE', { nonNullable: true, validators: Validators.required })
  });

  @Select(AcademicState.licenseScope)
  licenseScope$: Observable<LicenseScope | null>;

  ngOnInit(): void {
    this.licenseScope$
      .pipe(
        tap(licenseScope => this.selectLicenseScope(licenseScope ?? 'PERSONAL_USE')),
        untilDestroyed(this)
      )
      .subscribe();
  }

  selectLicenseScope(licenseScope: LicenseScope): void {
    this.teacherToggleForm.patchValue({ licenseScope });
  }

  submitForm(value: { licenseScope: LicenseScope }): void {
    this.saveLicenseScopeAndNavigate(value.licenseScope, '../verify-employee');
  }

  goBack(): void {
    this.saveLicenseScopeAndNavigate(this.teacherToggleForm.value.licenseScope ?? 'PERSONAL_USE', '../academic-registration');
  }

  private saveLicenseScopeAndNavigate(licenseScope: LicenseScope, route: string): void {
    this.store
      .dispatch(new SetLicenseScope(licenseScope))
      .pipe(
        switchMap(() => this.store.dispatch(new Navigate([route], { relativeTo: this.activatedRoute }))),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
